import Divider from 'components/divider';
import * as React from 'react';

import PromotionalCard from 'components/promotional-card';

type SidebarCard = {
  byline: string;
  description: string;
  heading: string;
  title: string;
  image_url: string;
  link_text: string;
  link_url: string;
};

type TopicSidebarProps = {
  data: SidebarCard;
};

function TopicSidebar({ data }: TopicSidebarProps): React.ReactNode {
  return (
    // 300px per design to match ad's width
    <aside style={{ maxWidth: 300 }}>
      <Divider className="my-10 md:hidden lg:my-12 lg:block" />
      <PromotionalCard
        byline={data.byline}
        description={data.description}
        href={data.link_url}
        imageUrl={data.image_url}
        linkText={data.link_text}
        title={data.title}
        heading={data.heading}
      />
    </aside>
  );
}

export default TopicSidebar;
